import { mapLocalePreferenceToIntlLocale } from '../../common/utils/datetime/friendlyDateFormatterIntl';

type CurrencyOption = {
    id: string;
    label: string;
    currencyCode: string;
};

export const getCurrencyDropdownLabel = ({
    label,
    currencyCode,
}: Pick<CurrencyOption, 'label' | 'currencyCode'>): string => {
    if (!currencyCode || currencyCode === label) return label;
    return `${label} (${currencyCode})`;
};

const getCurrencyDisplayName = (currencyCode: string, locale: string): string => {
    if (!currencyCode) return '';
    const intlLocale = mapLocalePreferenceToIntlLocale(locale);
    const displayName = new Intl.DisplayNames(intlLocale, { type: 'currency' }).of(currencyCode);
    // Fallback to code if display name is not available or is the same as code
    return !displayName || displayName === currencyCode ? currencyCode : displayName;
};

export const getCurrencyList = (locale: string): Array<CurrencyOption> => {
    // @ts-ignore - valid property of Intl
    const supportedCurrencyCodes = Intl.supportedValuesOf('currency');

    const currencyOptions = supportedCurrencyCodes.map((currencyCode: string) => ({
        id: currencyCode,
        label: getCurrencyDisplayName(currencyCode, locale),
        currencyCode,
    }));

    return currencyOptions.sort((a: CurrencyOption, b: CurrencyOption) => {
        if (a.label < b.label) return -1;
        if (a.label > b.label) return 1;
        return 0;
    });
};
